import {
  ProductSizes,
  ReboundOrder,
  ReboundReturnedItem,
  ReboundSalesItem,
  ReturnsOrder
} from '@api/returns/types'
import { buildLegacyReturnsObject } from '../helpers/builderLegacyReturnsObject'
import { mapReboundSaleItemToReturnProduct } from './mapReboundSaleItemToReturnProduct'
import { buildLegacyCarriers } from '../helpers/buildLegacyCarriers'
import { toOrderNumber } from '../helpers'

const first = <T,>(a?: T[]) => (a && a.length ? a[0] : undefined)
export const gidNum = (gid?: string | null) =>
  gid ? gid.match(/\/(\d+)$/)?.[1] ?? gid : undefined
export const getMeta = (m: ReboundSalesItem['clientMetadata'], k: string) =>
  m?.find(x => x.key === k)?.value

export const mapSizes = (
  _productType: string | null | undefined,
  sizes: ReboundReturnedItem['sizes']
) => {
  if (!sizes) return {}
  const out: Partial<ProductSizes> = {}
  if ('chest_size' in sizes) out.size = sizes.chest_size
  if ('size' in sizes) out.size = sizes.size
  if ('cut' in sizes) out.cut = sizes.cut
  if ('length' in sizes) out.length = sizes.length
  if ('waist' in sizes) out.waist = sizes.waist
  if ('build' in sizes) out.build = sizes.build
  if ('leg' in sizes) out.leg = sizes.leg
  if ('shortsleg' in sizes) out.leg = sizes.shortsleg
  if ('amount' in sizes) out.amount = sizes.amount
  return out
}

export async function mappedReboundApiToReturn(
  newResp: ReboundOrder
): Promise<ReturnsOrder> {
  const order = newResp.order
  const items = order.salesItems || []
  const returnedItems = order.returns || undefined
  const firstItem = first(items)

  const currency = firstItem?.commercialValue?.currency || 'GBP'
  const customerEmail = order.customerAddress?.email

  const products = await Promise.all(
    items.map((rawItem, idx) =>
      mapReboundSaleItemToReturnProduct(rawItem, newResp, idx)
    )
  )

  const legacyReturns = await buildLegacyReturnsObject(returnedItems, newResp)

  const carriers = await buildLegacyCarriers(newResp.postalServices)

  return {
    customer: {
      id: Number(order.customerId),
      email: customerEmail,
      address: order.customerAddress
    },
    order_number: toOrderNumber(order.clientOrderId),
    sale_order_id: order.salesOrderId,
    max_date: order.maxDate,
    currency,
    expired: order.expired,
    carriers,
    postcode: order.customerAddress.postalCode,
    products,
    returns: legacyReturns
  }
}
